import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

export interface TopicDialogData {
  parentTopicId: string;
  parentName: string;
  parentLevel: number;
  isRename?: boolean; // Flag to indicate if this is for renaming
  existingNameEng?: string; // Existing English name for renaming
  existingNameHindi?: string; // Existing Hindi name for renaming
  topicId?: string; // Topic ID for renaming
  isSubject?: boolean; // Flag to indicate if this is a top-level subject
}

@Component({
  selector: 'app-topic-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.isRename ? 'Rename Topic' : (data.isSubject ? 'Add New Subject' : 'Add New Topic') }}</h2>
    <div mat-dialog-content>
      <form [formGroup]="topicForm">
        <p *ngIf="!data.isRename && !data.isSubject" class="parent-info">Parent: {{ data.parentName }} (Level: {{ data.parentLevel }})</p>
        <p *ngIf="data.isRename" class="parent-info">Topic: {{ data.parentName }}</p>
        <p *ngIf="data.isSubject" class="parent-info">Creating a new top-level subject</p>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ data.isSubject ? 'Subject Name (English)' : 'English Name' }}</mat-label>
          <input matInput formControlName="nameEng" placeholder="{{ data.isSubject ? 'Enter subject name in English' : 'Enter topic name in English' }}">
          <mat-error *ngIf="topicForm.get('nameEng')?.hasError('required')">
            {{ data.isSubject ? 'Subject' : 'Topic' }} name is required
          </mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ data.isSubject ? 'Subject Name (Hindi)' : 'Hindi Name' }}</mat-label>
          <input matInput formControlName="nameHindi" placeholder="{{ data.isSubject ? 'Enter subject name in Hindi (optional)' : 'Enter topic name in Hindi (optional)' }}">
        </mat-form-field>
      </form>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary" [disabled]="topicForm.invalid" [mat-dialog-close]="topicForm.value">
        {{ data.isRename ? 'Rename' : 'Create' }}
      </button>
    </div>
  `,
  styles: [`
    .full-width {
      width: 100%;
      margin-bottom: 15px;
    }
    .parent-info {
      margin-bottom: 15px;
      font-style: italic;
      color: #666;
    }
  `]
})
export class TopicDialogComponent {
  topicForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<TopicDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TopicDialogData
  ) {
    // Initialize form with existing values if in rename mode
    this.topicForm = this.fb.group({
      nameEng: [data.isRename ? data.existingNameEng || '' : '', Validators.required],
      nameHindi: [data.isRename ? data.existingNameHindi || '' : '']
    });
  }
} 